import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { StyledSearchBar } from "./_.styled";
import { LinksList } from "../../../components";
import { transformAgents, transformDiseases } from "./transformUtils";
import { useSearch } from "../../../hooks/useSearch";

const ListSection = ({ diseases, agents, onItemClick, noDataText }) => {
  const { searchTerm, handleSearchTermChange, searchUtils } = useSearch();

  const filteredList = useMemo(
    () =>
      (diseases && transformDiseases({ diseases, searchUtils })) ||
      (agents && transformAgents({ agents, searchUtils })) ||
      [],
    [diseases, agents, searchUtils]
  );

  return (
    <>
      <StyledSearchBar value={searchTerm} onChange={handleSearchTermChange} />
      <LinksList
        items={filteredList}
        onItemClick={onItemClick}
        noDataText={noDataText}
      />
    </>
  );
};

const baseDiseasePropType = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  href: PropTypes.string,
};

ListSection.propTypes = {
  diseases: PropTypes.arrayOf(
    PropTypes.shape({
      ...baseDiseasePropType,
      subTypes: PropTypes.arrayOf(PropTypes.shape(baseDiseasePropType)),
    })
  ),
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
  noDataText: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired,
};

export default ListSection;
